export default __webpack_public_path__ + "static/media/officebee.e5b3504f.jpg";